import { $, $$ } from '@/utilities/helpers';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { Api } from './game/index';

let API = new Api('');

// let $redeemPrizeButton = $$('.js-redeem-prize');

document.addEventListener('click', (e) => {

    if (e.target && e.target.classList.contains('js-redeem-prize')) {
        e.preventDefault();
        let $button = e.target;
        let $prize = $button.closest('.js-prize-item');

        let url = $button.dataset.apiUrl;
        let $variationSelect = $prize.querySelector('.js-variation-select');
        let uid = $prize.dataset.uid;
        let variation = ($variationSelect) ? $variationSelect.value : '';


        Swal.fire({
            customClass: { container: 'fullSwal' },
            title: 'Claim your prize?',
            html: `You have selected to redeem the prize <strong>${$prize.dataset.title}</strong>.<br>You cannot undo this action.`,
            showCancelButton: true,
            input: "textarea",
            inputLabel: "Delivery address / Notes",
            inputPlaceholder: "Type your delivery address here",
            confirmButtonText: 'Redeem',
        }).then((result) => {
            if (result.isConfirmed) {
                API.post(url, {
                    prize: uid,
                    variation: variation,
                    delivery_address: result.value || '',
                }).then((response) => {
                    console.log(response)
                    if (!response.status === 'iok') {
                        window.Toast.fire({ title: `Error!`, text: response.message, timer: 8000, icon: 'error' });
                    } else {
                        window.Toast.fire({ title: `Congrats!`, text: 'You have successfully claimed your prize', timer: 5000, icon: 'success' });
                        setTimeout(() => {
                            window.location.reload();
                        }, 5000);
                    }
                }).catch((error) => {
                    console.log(error)
                    let message = 'Something went wrong. Please try again.';
                    try {
                        message = JSON.parse(error.message).message || message;
                    } catch (e) {}
                    window.Toast.fire({ title: `Error!`, text: message, timer: 8000, icon: 'error' });
                })
            }
        })

    };
})


// $redeemPrizeButton.forEach((button) => {
//     button.addEventListener('click', (e) => {
//         e.preventDefault();
//         let $button = e.currentTarget;
//         let $prize = $button.closest('.js-prize-item');

//         let url = $button.dataset.apiUrl;
//         let $variationSelect = $prize.querySelector('.js-variation-select');
//         let uid = $prize.dataset.uid;
//         let variation = ($variationSelect) ? $variationSelect.value : '';

//         Swal.fire({
//             customClass: { container: 'fullSwal' },
//             title: 'Claim your prize?',
//             html: `You have selected to redeem the prize <strong>${$prize.dataset.title}</strong>.<br>You cannot undo this action.`,
//             showCancelButton: true,
//             input: "textarea",
//             inputLabel: "Delivery address / Notes",
//             inputPlaceholder: "Type your delivery address here",
//             confirmButtonText: 'Redeem',
//         }).then((result) => {
//             if (result.isConfirmed) {
//                 API.post(url, {
//                     prize: uid,
//                     variation: variation,
//                     delivery_address: result.value || '',
//                 }).then((response) => {
//                     console.log(response)
//                     if (!response.status === 'iok') {
//                         window.Toast.fire({ title: `Error!`, text: response.message, timer: 8000, icon: 'error' });
//                     } else {
//                         window.Toast.fire({ title: `Congrats!`, text: 'You have successfully claimed your prize', timer: 5000, icon: 'success' });
//                         setTimeout(() => {
//                             window.location.reload();
//                         }, 5000);
//                     }
//                 }).catch((error) => {
//                     console.log(error)
//                 })
//             }
//         })

//         // &variation=UID


//     });
// });